module.exports = __webpack_public_path__ + "static/media/header_bg.4d819f8e.png";